<template>
    <div style="position: relative">
        <div v-if="isTopSearch === 1"
             class="topBarSearch topBarSearch-specail"
             :class="!isLogin || this.isLogin === 'undefined' ? 'topBarSearch-specail-cc': ''">
            <div class="editor">
                <i class="iconfont icon-close" @click="closeTopSearch"></i>
                <input type="text"
                       v-if="localImgSearch && imgUrlKey"
                       ref="searchBoxcc"
                       v-model="wordscc"
                       @keyup="keyupcc($event)"
                       @input="searchInputcc"
                       style="width: 200px;position: absolute;left: 40px;top:2px;padding-left: 20px;">
                <input type="text"
                       v-else
                       ref="searchBoxcc"
                       v-model="wordscc"
                       @keyup="keyupcc($event)"
                       @input="searchInputcc"
                       style="width: 200px;position: absolute;left: 30px;top:2px;"
                       placeholder="请输入关键词进行搜索">
                <div class="imgSearchSmall" v-if="localImgSearch && imgUrlKey">
                    <div class="img-con">
                        <img :src="baseImgUrl + imgUrlKey" alt="">
                    </div>
                </div>
            </div>
            <span ref="spanWord" class="span-word">{{wordscc}}</span>
        </div>

        <div v-if="isListPage" class="search-box search-list-box bg-fff" :class="(localImgSearch && isSearchShow) ? 'search-box-specail' : ''">
            <!-- <router-link class="logo col" :to="{name:'homePage'}">
                <span class="searchBoxLogo searchBoxLogo-list">
                    <i class="iconfont icon-zhulogiclogo-"></i>
                </span>
                    <span class="yunlogic yunlogic-list">
                        <i class="iconfont icon-ccdlogo"></i>
                </span>
            </router-link> -->
            <div class="editor" style="position: relative;margin-top:8px;">
                <input v-if="localImgSearch && isSearchShow" type="text" ref="searchBox" v-model="words" @keyup="keyup($event)" @input="searchInput"
                       style="width: 403px;margin-right: 10px;padding-left: 80px;">
                <input v-else type="text" ref="searchBox" v-model="words" @keyup="keyup($event)" @input="searchInput"
                       style="width: 403px;margin-left: 10px;"
                       placeholder="请输入关键词进行搜索">
                <img-search :type="1" @changeImgSearch="changeImgSearch"></img-search>
                <div class="imgSearchSmall" v-if="imgUrlKey && localImgSearch && isSearchShow">
                    <i class="iconfont icon-close" @click="closeImgSearchHandle"></i>
                    <div class="img-con">
                        <img :src="baseImgUrl + imgUrlKey" alt="">
                    </div>
                </div>
                <div class="imgSearchBg" v-if="imgUrlKey && localImgSearch && isSearchShow">
                    <img :src="baseImgUrl + imgUrlKey" alt="">
                </div>
            </div>
            <div class="search-icon icon-div icon-div-specail" style="margin-top:8px;" @click="search">
                <i class="iconfont icon-sousuo" style="font-size:22px;"></i>
            </div>
            <span ref="spanWord" class="span-word">{{words}}</span>
        </div>


        <div v-if="isTopSearch === 0 && !isListPage" class="search-box bg-fff">
            <router-link class="logo col" :to="{name:'homePage'}">
            <span class="searchBoxLogo">
                <i class="iconfont icon-zhulogiclogo-"></i>
            </span>
                <span class="yunlogic">
                    <i class="iconfont icon-ccdlogo"></i>
            </span>
            </router-link>
            <div class="editor">
                <input type="text" ref="searchBox" v-model="words" @keyup="keyup($event)" @input="searchInput"
                       style="width: 403px;margin-right: 13px;"
                       placeholder="请输入关键词进行搜索">
                <img-search></img-search>

                <div class="inputBottomButton">
                <span class="showSpan" style="margin-right:33px;">
                    <router-link :to="{name: 'inspirationList'}">
                        灵感源
                    </router-link>
                </span>
                    <!-- <span> | </span>
                    <span class="showSpan">
                     <router-link :to="{name: 'planList'}">
                        场景库
                    </router-link> -->
                    <!-- </span> -->
                    <span> | </span>
                    <span class="showSpan">
                    <router-link :to="{name: 'productList'}">
                      产品库
                    </router-link>
                </span>
                </div>
            </div>

            <div class="search-icon icon-div" @click="search">
                <i class="iconfont icon-sousuo" style="font-size:22px;"></i>
            </div>
            <span ref="spanWord" class="span-word">{{words}}</span>
        </div>

        
    </div>


</template>
<script>
    import imgSearch from './imgSearch.vue'
    import api from '../../api'
    export default{
        props: {
            keyword: {
                type: String,
                default: ''
            },
            isTopSearch: {
                type: Number,
                default: 0
            },
            isListPage: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                isLogin: localStorage.getItem("token"),
                words: this.keyword,
                wordscc: this.$route.query.keyword || '',
                inputWidth:'auto',
                baseImgUrl: api.common.imgBaseUrl,
                imgUrlKey : localStorage.getItem("imgSearchLocal") === 'null' ? null : localStorage.getItem("imgSearchLocal"),
                localImgSearch:this.$route.query.imgsearch || null,
                isSearchShow: true
            }
        },
        components:{
            imgSearch
        },
        methods: {
            changeImgSearch(){
              this.$emit('changeImgSearchHandle')
            },
            closeTopSearch(){
                this.$emit('closeSearch')
            },
            clear(){
                this.words = '';
                this.wordscc = '';
                this.$emit('search', 'keyword', this.words);
                this.$emit('search', 'keyword', this.wordscc);
            },
            keyup(e){
                if (e.key == 'Enter'||e.keyCode == 13) {
                    this.search();
                }
            },
            keyupcc(e){
                if (e.key == 'Enter'||e.keyCode == 13) {
                    this.searchcc();
                }
            },
            closeImgSearchHandle(){
                this.isSearchShow = false;
                localStorage.setItem("imgSearchLocal", null);
                this.search();
                this.searchcc();
            },
            search(){
                this.words = this.words.trim();
                this.isSearchShow = false;
                if(this.words){
                    this.$emit('search', 'keyword', this.words.trim());
                }
                if(this.words=== ''){
                    this.$emit('search', 'keyword', '');
                }
            },
            searchcc(){
                this.wordscc = this.wordscc.trim();
                this.isSearchShow = false;
                if(this.wordscc){
                    this.$emit('search', 'keyword', this.wordscc.trim());
                }
                if(this.wordscc === ''){
                    this.$emit('search', 'keyword', '');
                }
            },
            searchInput(){
                this.words = this.$refs.searchBox.value;
                if(this.words){
                    this.$emit('changeValue',  this.words)
                }
                this.$nextTick(()=>{
                    this.inputWidth = this.$refs.spanWord.offsetWidth+20+'px';
                });
                if(this.words.length>20){
                    this.words = this.words.trim().slice(0,20);
                }
            },
            searchInputcc(){
                this.wordscc = this.$refs.searchBoxcc.value;
                if(this.wordscc){
                    this.$emit('changeValue',  this.words)
                }
                this.$nextTick(()=>{
                    this.inputWidth = this.$refs.spanWord.offsetWidth+20+'px';
                });
                if(this.wordscc.length>20){
                    this.wordscc = this.wordscc.trim().slice(0,20);
                }
            },
        },
        mounted(){
            if(this.$refs.searchBox){
                this.$refs.searchBox.focus();
            }
            if(this.$refs.searchBoxcc){
                this.$refs.searchBoxcc.focus();
            }
        }
    }
</script>
<style scoped>
    .search-box {
        background-color: #fff;
        height: 100px;
        line-height: 36px;
        padding: 25px 0;
        text-align: center;
        position:relative;
    }
    .span-word{
        font-size: 28px;
        position:absolute;
        white-space: nowrap;
        visibility: hidden;
    }
    .searchBoxLogo{
        position:absolute;
        width: 74px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        left: 50px;
        top:18px;
        /*padding: 6px 10px;*/
        padding: 0 !important;
        background: #FFD600;
        border-radius: 4px;
    }
    .searchBoxLogo i{
       font-size: 30px;
    }
    .searchBoxLogo-list{
        left: 8px;
    }
    .yunlogic{
        position:absolute;
        left: 127px;
        top:24px;
    }
    .yunlogic-list{
        left: 85px;
    }
    .yunlogic > i{
        font-size: 40.5px;
        color: #f5a623;
        float: left;
        margin-top: -1px;
        margin-left: 4px;
    }
    .search-box .search-icon .icon-search{
        font-size:20px;
    }
    .search-box .editor {
        font-size: 20px;
        text-align: left;
        vertical-align: middle;
        margin-top: -6px;
        float: right;
        margin-right: 60px;
    }

    .search-box .editor input {
        font-size: 16px;
        color: #308697;
        text-shadow: 0px 0px 0px  #353838;
        -webkit-text-fill-color: transparent;
        background:transparent;
        text-align:left;
        white-space: nowrap;
        border: 2px solid  #cccccc;
        padding-left: 40px;
    }

    .search-box .editor input::-webkit-input-placeholder { /* WebKit browsers */
        font-size: 16px;
        color: #CCC;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search-box .editor input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        font-size: 16px;
        color: #CCC;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search-box .editor input::-moz-placeholder { /* Mozilla Firefox 19+ */
        font-size: 16px;
        color: #CCC;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search-box .editor input:-ms-input-placeholder { /* Internet Explorer 10+ */
        font-size: 16px;
        color: #CCC;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .search-box .editor input,
    .search-box .editor input:focus,
    .search-box .editor input:hover {
        /*border: 0 none;*/
        outline: none;
        box-shadow: none;
    }
    .search-box .editor .inputBottomButton{
        width: 100%;
    }
    .search-box .editor .inputBottomButton span{
        font-size: 12px;
        color: #6C6F70;
        float: right;
        margin-right: 25px;
    }
    .search-box .editor .inputBottomButton span:first-child{
        margin-right: -9px;
    }
    .search-box .editor .inputBottomButton span.showSpan{
        cursor: pointer;
    }
    .search-box .editor .inputBottomButton span.showSpan:hover{
        color:#308697;
    }

    .search-box .icon-div {
        width: 44px;
        vertical-align: middle;
        margin-top: -6px;
        float: right;
        margin-right: -45px;
        cursor: pointer;
        position: relative;
        z-index: 10;
        color:#fff;
        text-align: center;
    }
    .search-box  .icon-div-specail{
        background: #ffd600;
        margin-left: 10px;
    }
    .search-box .icon-div i{
        color:#ccc;
        cursor: pointer;
        display: inline-block;
        margin-top: 3px;
    }
    .search-box .icon-div:hover{
        opacity: 0.8;
    }
    .search-box .icon-div i:hover{
        opacity: 0.8;
    }

    .topBarSearch-specail{
        position: absolute;
        border: 1px solid #979797;
        border-radius: 4px;
        width: 280px;
        right: 585px;
        height: 30px;
        top:11px;
    }
    .topBarSearch-specail-cc{
        right: 205px;
    }

    .topBarSearch .editor {
        font-size: 20px;
        text-align: left;
        vertical-align: middle;
        float: left;
        height: 100%;
        margin-top: -2px;
        margin-left: 50px;
    }
    .topBarSearch .editor i{
        font-size: 12px;
        color: rgba(0,0,0,0.65);
        vertical-align: middle;
        cursor: pointer;
        margin-right: 7px;
    }

    .topBarSearch .editor input {
        font-size: 14px;
        color: #353838;
        height: 24px;
        text-shadow: 0px 0px 0px  #353838;
        -webkit-text-fill-color: transparent;
        background:transparent;
        text-align:left;
        border:none;
        white-space: nowrap;
    }

    .topBarSearch .editor input::-webkit-input-placeholder { /* WebKit browsers */
        font-size: 14px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .topBarSearch .editor input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        font-size: 14px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .topBarSearch .editor input::-moz-placeholder { /* Mozilla Firefox 19+ */
        font-size: 14px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .topBarSearch .editor input:-ms-input-placeholder { /* Internet Explorer 10+ */
        font-size: 14px;
        color: #A2A2A8;
        text-shadow: none;
        -webkit-text-fill-color: initial;
    }

    .topBarSearch .editor input,
    .topBarSearch .editor input:focus,
    .topBarSearch .editor input:hover {
        /*border: 0 none;*/
        outline: none;
        box-shadow: none;
    }

    .topBarSearch-specail .editor{
        margin-top: 0px;
        width: 100%;
        margin-left: 0px;
    }
    .topBarSearch-specail .editor i{
        position: absolute;
        left: 10px;
        top:-10px;
    }
    .search-box .editor .imgSearchSmall, .topBarSearch .editor .imgSearchSmall{
        position: absolute;
        top: 0px;
        left: 20px;
        font-size: 0px;
    }
    .topBarSearch .editor .imgSearchSmall{
        top: -12px;
        left: 30px;
    }
    .search-box .editor .imgSearchSmall .img-con, .topBarSearch .editor .imgSearchSmall .img-con{
        width: 26px;
        height: 20px;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
        text-align: center;
    }
    .search-box .editor .imgSearchSmall i{
        font-size: 12px;
        vertical-align: top;
        color:rgba(0,0,0,0.65);
        margin-right: 12px;
        cursor: pointer;
        margin-top: 2px;
        display: inline-block;
    }
    .search-box .editor .imgSearchSmall .img-con img,  .topBarSearch .editor .imgSearchSmall .img-con img{
        /*width: 100%;*/
        height: 100%;
        display: inline-block;
        vertical-align: middle;
    }
    .search-box .editor .imgSearchBg{
        position: absolute;
        /*width: 150px;*/
        height: 120px;
        text-align: left;
        line-height: 120px;
        vertical-align: top;
        left: 47px;
        top:55px;
    }
    .search-box .editor .imgSearchBg img{
        /*min-width: 100%;*/
        max-height: 100%;
        vertical-align: top;
        display: inline-block;
    }


</style>
<style rel="stylesheet/scss" lang="scss" scoped>
    .search-list-box{
        text-align: center;
        min-width: 1200px;
        .logo{
            width: 200px;
            display: inline-block;
            position: relative;
            height: 50px;
            .searchBoxLogo{
                top:3px;
            }
            .yunlogic{
                top:5px;
                margin-top: 5px;
            }
        }
        .editor{
            float: none;
            margin-right: 0;
            margin-left: 35px;
            margin-top: -40px;
            display: inline-block;
            input{
                border: 2px solid #C8CCCC;
                border-radius: 4px;
                padding-left: 10px;
            }
        }
        .icon-div{
            display: none;
            float: none;
            margin-right: 0px;
            margin-top: -40px;
            display: inline-block;
            border-radius: 4px;
            i{
                color:#fff;
            }
        }
    }
    .search-box-specail{
        margin-bottom: 123px;
    }
</style>